var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardIconMessage = function SvgCardIconMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.5 3h-9C2.673 3 2 3.673 2 4.5v6.75c0 .827.673 1.5 1.5 1.5h2.25v1.968c0 .23.262.363.447.227l2.928-2.196h3.374c.828 0 1.5-.672 1.5-1.5V4.5C14 3.674 13.327 3 12.5 3"
  })));
};
export default SvgCardIconMessage;